export const CHANGE_LANGUAGE = 'header/change_language';
